<script setup>

import { ref, onMounted, watch } from "vue";
import ERP from "../../api/v2/ERP.mjs";
import View from "../../api/v2/View.mjs";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";
import SolicitarRevisaoModal from "./SolicitarRevisao/SolicitarRevisaoModal.vue";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//======================= Campos de Controle =======================//
//==================================================================//

const controlesDesativados = ref(false);
const solicitandoRevisao = ref(false);

//==================================================================//
//======================== Pedido de Compra ========================//
//==================================================================//

const pedidosDeCompra = ref([]);
const pedidoDeCompraLoading = ref(true);
const pedidoDeCompraSelecionado = ref({});

//==================================================================//
//======================== Campos de Busca =========================//
//==================================================================//

const buscaGeral = ref("");

//==================================================================//
//==================== Pedidos de Compra Header ====================//
//==================================================================//

let pedidoDeCompraHeaders = [
    { text: '',                                         value: 'criar',             class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Pedido',                                   value: 'codigo',                    class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Status',                                   value: 'status',                    class:"c-pedido__header",    cellClass:'c-pedido__cell', filterable: false},
    { text: 'Fornecedor',                               value: 'fornecedor.nome',           class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Vendedor(a)',                              value: 'fornecedorVendedor.nome',   class:"c-pedido__header",    cellClass:'c-pedido__cell'},
]

//==================================================================//
//===================== Load Pedidos de Compra  ====================//
//==================================================================//

const loadPedidosDeCompra = async () =>{

    pedidoDeCompraLoading.value = true;

    const pedidosDeCompraResponse = await ERP.getManyWithView(View.PEDIDO_DE_COMPRA_SOLICITAR_REVISAO,[
        {
            name: "owner",
            dataType: "String",
            value: usuarioStore.usuario.id
        },
    ]);

    pedidosDeCompra.value = pedidosDeCompraResponse.data;

    clearBuscaGeral();

    pedidoDeCompraLoading.value = false;

};

//==================================================================//
//======================== Fill Buscadores =========================//
//==================================================================//

const clearBuscaGeral = () =>{
    buscaGeral.value = "";
};

//==================================================================//
//================== Altera Solicitando Revisao =====================//
//==================================================================//

const alteraSolicitandoRevisando = (update)=>{

    solicitandoRevisao.value = update.solicitandoRevisao;
    pedidoDeCompraSelecionado.value = update?.pedidoDeCompra || {};

    if(solicitandoRevisao.value == false){
        loadPedidosDeCompra();
    }


};

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    controlesDesativados.value = update.controlesDesativados;

};

//==================================================================//
//==================== Ao Solicitar Revisao ========================//
//==================================================================//

const aoSolicitarRevisao = (item)=>{

    alteraSolicitandoRevisando({
        solicitandoRevisao: true,
        pedidoDeCompra: item
    });

}

//==================================================================//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async ()=>{

   await loadPedidosDeCompra();

});

</script>

<template>

    <main 
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>
            Solicitar Revisões
        </h2>

        <v-card>

            <v-card-title
                class="c-pedido-holder"
            >

                <h3
                    class="c-pedido__titulo"
                >
                    Pedidos de Compra
                </h3>

                <div
                    class="c-pedido__buscas"
                >

                    <v-text-field
                        label="Buscar"
                        class="c-busca__geral"
                        v-model="buscaGeral"
                        append-icon="mdi-magnify"
                        single-line
                        hide-details
                        outlined
                        clearable
                        :disabled="controlesDesativados"
                    >
                    </v-text-field>

                </div>

                <v-chip
                    class="c-comprador"
                    label
                >

                    <v-icon left>
                        mdi-account-circle-outline
                    </v-icon>
                    Comprador:
                    {{colaboradorStore.colaborador.nome}}

                </v-chip>

            </v-card-title>

            <v-data-table
                class="c-pedido__tabela elevation-1"
                :headers="pedidoDeCompraHeaders"
                :items="pedidosDeCompra"
                :search="buscaGeral"
                :items-per-page="-1"
                select-strategy="all"
                item-key="id"
                return-object
                :loading="pedidoDeCompraLoading"
                loading-text="Carregando... Por favor, aguarde."
            >

                <template v-slot:item.criar="{ item }">

                    <v-tooltip bottom>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                class="c-criar-solicitacar-revisao mx-2"
                                fab
                                dark
                                small
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                :disabled="controlesDesativados"
                                @click="aoSolicitarRevisao(item)"
                            >

                                <v-icon dark>
                                    mdi-invoice-text-edit
                                </v-icon>
                            
                            </v-btn>

                        </template>

                        <span>Solicitar uma Revisão do Pedido de Compra</span>

                    </v-tooltip>

                </template>

            </v-data-table>

        </v-card>

        <SolicitarRevisaoModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pedidoDeCompra="pedidoDeCompraSelecionado"
            :controlesDesativados="controlesDesativados"
            :solicitandoRevisao="solicitandoRevisao"
            @update:solicitandoRevisao="alteraSolicitandoRevisando"
            @update:controlesDesativados="alteraControlesDesativados"
        ></SolicitarRevisaoModal>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

.c-main--disabled >>> .c-pedido__header{
    pointer-events: none;
    user-select: none; 
}

.c-pedido-holder{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    grid-template-areas: 
    "titulo ."
    "buscas comprador";
    gap: 10px;
}

.c-pedido__title { 
    grid-area: titulo;
}

.c-pedido__buscas { 
    grid-area: buscas;
}

.c-busca__geral{
    grid-area: buscaGeral;
}

.c-comprador{
    grid-area: comprador;
    margin: 0 20px;
    min-height: 48px;
}

.c-comprador >>> .v-chip__content{
    margin: auto;
}

.c-pedido__tabela{
    display: grid;
    white-space: nowrap;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-criar-solicitacar-revisao{
    background: #1976d2 !important;
    border-color: #1976d2 !important;
}

@media (width <= 850px) {
    
    .c-pedido-holder{
        grid-template-columns: 1fr; 
        grid-template-rows: auto 1fr auto; 
        grid-template-areas:
            "titulo"
            "comprador"
            "buscas";
    }

    .c-comprador{
        margin: 0;
    }

    .c-pedido__buscas { 
        grid-template-rows: 1fr; 
        grid-template-areas: 
            "buscaGeral";
    }

}

</style>